import { customSanitize } from "../../../utils/customSanitize";
import styles from "./Contact.module.scss";

import { LinkType } from "../../../types/baseTypes";
import { Button } from "../../Button/Button";

interface ContactProps {
  contact: {
    title: string;
    content: string;
    link?: LinkType;
  };
}

export const Contact = ({ contact }: ContactProps) => {
  if (!contact) return <></>;

  const { title, content, link } = contact;

  return (
    <div className={styles.contact}>
      <div className={``}>
        <span className="footer-headline h3 is-block">{title}</span>
      </div>
      <div
        className="footer-text"
        dangerouslySetInnerHTML={{ __html: customSanitize(content) }}
      />
      {link && typeof link === "object" && link.url && (
        <Button
          type="secondary"
          href={link.url}
          target={link.target}
          className="mt-4"
        >
          {link.title}
        </Button>
      )}
    </div>
  );
};
